import common from '../../global/common'
import {queryTwoPlatformInfoBase} from '../../api/robotManage/index'
import config from '../../config'
import Cookies from 'js-cookie'

let token = common.getCookie('kf_access_token')
const state = {
  // 是否登录
  sign: !!token,
  // 登录使用的token
  token: token,
  sider: [],
  collapse: false,
  // 所有二级平台列表
  platformList: [],
  // 所有二级平台列表(供机器人相关页面使用 青豆集团站点下 类型需要手动加上"说客青豆")
  specialPlatformList: [],
  // 平台信息
  platformInfo: {},
  // 用户信息
  userInfo: Cookies.get('kf_admin_userInfo') ? JSON.parse(Cookies.get('kf_admin_userInfo')) : {}
}

const mutations = {
  setUserInfo (state, data) {
    state.userInfo = data
    Cookies.set('kf_admin_userInfo', JSON.stringify(data))
  },
  clearUserInfo (state) {
    state.userInfo = {}
    Cookies.remove('kf_admin_userInfo')
  },
  setPlatformInfo (state, data) {
    state.platformInfo = data
  },
  login (state, userInfo) {
    mutations.setUserInfo(state, userInfo)
    common.setUserInfo(userInfo)
    state.sign = true
    state.name = userInfo.nickName
    state.token = userInfo.token
    state.userId = userInfo.userId
  },
  logout (state) {
    mutations.clearUserInfo(state)
    common.clearUserInfo()
    state.sign = false
    state.name = ''
    state.token = ''
    state.userId = ''
    state.sider = []
  },
  siderList (state, data) {
    state.sider = data
    // common.setSiderList(data)
  },
  toggleCollapse (state) {
    state.collapse = !state.collapse
  },
  setPlatformList (state, data) {
    state.platformList = [...data]
    state.specialPlatformList = [...data]
    if (location.host.split('.')[0] === 'platform' || config.subDomain === 'test') {
      // 青豆集团站点下
      state.specialPlatformList.push({
        id: 10,
        name: '说客青豆'
      })
    }
  }
}

const actions = {
  login: ({commit}, userInfo) => {
    commit('login', userInfo)
  },
  logout: ({commit}) => {
    commit('logout')
    commit('clearTabs', {}, {root: true})
  },
  siderList: ({commit}, data) => {
    commit('siderList', data)
  },
  toggleCollapse: ({ commit }) => {
    commit('toggleCollapse')
  },
  fetchGetPlatformList: async ({commit}) => {
    try {
      const {data} = await queryTwoPlatformInfoBase()
      if (data.resultCode === 0) {
        commit('setPlatformList', data.resultData)
      } else {
        return []
      }
    } catch (error) {
    }
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth-user.js